import { images } from "../../images";

export const BlogsListingData = [
  {
    id: 1,
    img: images.blogListing1.image,
    alt: images.blogListing1.alt,
    date: "01.05.2023",
    title: "Disconnections in the Design Industry: Concerns & Solutions",
    link: "",
  },
  {
    id: 2,
    img: images.blogListing2.image,
    alt: images.blogListing2.alt,
    date: "02.05.2023",
    title: "Bringing a Revolution in the Business of Design through Technology",
    link: "",
  },
  {
    id: 3,
    img: images.blogListing3.image,
    alt: images.blogListing3.alt,
    date: "02.06.2023",
    title:
      "From Search to Reach: Mastering Information Retrieval Techniques for Design Professionals",
    link: "",
  },
  {
    id: 4,
    img: images.blogListing1.image,
    alt: images.blogListing1.alt,
    date: "01.05.2023",
    title: "Disconnections in the Design Industry: Concerns & Solutions",
    link: "",
  },
  {
    id: 5,
    img: images.blogListing2.image,
    alt: images.blogListing2.alt,
    date: "02.05.2023",
    title: "Bringing a Revolution in the Business of Design through Technology",
    link: "",
  },
  {
    id: 6,
    img: images.blogListing3.image,
    alt: images.blogListing3.alt,
    date: "02.06.2023",
    title:
      "From Search to Reach: Mastering Information Retrieval Techniques for Design Professionals",
    link: "",
  },
];

export const BlogsInnerData = [
  {
    id: 1,
    heroImg: images.hero1.image,
    heroAlt: images.hero1.alt,
    facebookLink: "",
    instaLink: "",
    linkedInLink: "",
    desc: [
      `In today’s time, the architecture and design industry does
      not rely heavily on effective networking and marketing
      strategies for success. However, these strategies are
      crucial for attracting clients, building professional
      relationships, and staying ahead of the competition. Here
      are some common concerns professionals face in networking
      and marketing and tips on how to fix them:`,
      `Inadequate Communication Channels Networking and
      marketing efforts rely on effective communication channels
      to reach the target audience. Unfortunately, the
      architecture and design industry often faces challenges
      finding the right platforms and mediums to communicate their
      work and expertise. The digital landscape continuously
      evolves, making it difficult for professionals to keep up
      with the latest trends and choose the most effective online
      platforms for promotion. Professionals must adapt to
      changing communication trends and leverage a singular
      platform to connect with their target audience. This
      includes having a solid online presence, active social media
      profiles, and engaging content showcasing their expertise
      and projects.`,
      `Lack of Personal Branding Personal branding is
      crucial in establishing a professional identity and standing
      out in a highly competitive industry. Many architects and
      designers must be convinced that the work alone is not
      enough to create more buzz for the business. Instead, the
      design ecosystem should define its strengths, values, and
      philosophy and engage with the community. Professionals can
      build a recognisable and memorable reach by consistently
      showcasing the business through its portfolio, online presence,
      and communication style.`,
      `Insufficient Digital Networking Networking is vital for
      succeeding in the architecture and design industry. Failing
      to build and nurture a solid digital network can hinder
      professional growth and limit access to hyperlocal clients
      and collaborators in a field that relies heavily on
      referrals and recommendations. Attending industry events,
      joining professional organisations, participating in
      conferences and workshops, and engaging with online
      communities are effective ways to expand one's network.
      Architects and designers can tap into vast resources to help
      build and maintain digital relationships with other
      professionals, clients, suppliers, and influencers.`,
      `Lack of Targeted Marketing Strategies A common mistake in
      the design industry is adopting a generalised approach to
      marketing. Professionals can effectively reach their ideal
      clients online with a targeted marketing strategy.
      Architects and designers should invest time understanding
      their target audience, needs, preferences, and pain points.
      Professionals can create custom profiles and campaigns that
      resonate with their intended audience and address specific
      client segments.`,
      `Networking and marketing are critical for success in the
      architecture and design industry. By acknowledging and
      addressing the loopholes and disorientations that
      professionals often encounter, one can develop effective
      strategies for growth.`,
    ],
  },
];
